export default "__VITE_ASSET__nHFw8FlK__"